/**
 * 认证相关工具函数
 */

const TokenKey = 'token'
const UserInfoKey = 'user_info'

/**
 * 获取Token
 */
export function getToken() {
  return localStorage.getItem(TokenKey)
}

/**
 * 设置Token
 * @param {string} token 
 */
export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

/**
 * 移除Token
 */
export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  const userInfo = localStorage.getItem(UserInfoKey)
  return userInfo ? JSON.parse(userInfo) : null
}

/**
 * 设置用户信息
 * @param {Object} userInfo 
 */
export function setUserInfo(userInfo) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

/**
 * 移除用户信息
 */
export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}

/**
 * 清除所有认证信息
 */
export function clearAuth() {
  removeToken()
  removeUserInfo()
}

/**
 * 检查是否有权限
 * @param {string|Array} permission 权限标识
 * @returns {boolean}
 */
export function hasPermission(permission) {
  const userInfo = getUserInfo()
  if (!userInfo || !userInfo.permissions) {
    return false
  }
  
  const permissions = userInfo.permissions
  
  if (Array.isArray(permission)) {
    return permission.some(p => permissions.includes(p))
  }
  
  return permissions.includes(permission)
}

/**
 * 检查是否有指定角色
 * @param {string|Array} role 角色标识
 * @returns {boolean}
 */
export function hasRole(role) {
  const userInfo = getUserInfo()
  if (!userInfo || !userInfo.roles) {
    return false
  }
  
  const roles = userInfo.roles
  
  if (Array.isArray(role)) {
    return role.some(r => roles.includes(r))
  }
  
  return roles.includes(role)
} 